import React, { useContext } from 'react'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import { GlobalContext } from '../../../../App'
import { regionLabels } from '../../../../helpers/region'

const DemographicsModule = ({ demographics }) => {
  const { tenantInfo } = useContext(GlobalContext)
  return (
    <>
      <DetailsBox
        title="Demographics"
        rows={[
          { label: 'Last Name', value: demographics?.lastName },
          { label: 'First Name', value: demographics?.firstName },
          { label: 'Preferred Name', value: demographics?.preferredName },
          {
            label: 'Date of Birth',
            value: demographics?.dob
              ? moment(demographics.dob).format('DD/MM/YYYY')
              : demographics?.dobUnkown
                ? 'Unknown'
                : '',
          },
          { label: 'Gender', value: demographics?.gender },
          {
            label: 'GP Surgery',
            value: demographics?.gpSurgery,
          },
          {
            label: regionLabels(tenantInfo?.region).nationalIdLabel,
            value: demographics?.nhsNumber,
          },
          {
            label: 'Address',
            value: [
              demographics?.addressLine1,
              demographics?.addressLine2,
              demographics?.town,
              demographics?.city,
              demographics?.postCode,
            ]
              .filter(Boolean)
              .join(', '),
            fullWidth: true,
          },
          {
            label: 'Contact Number',
            value: demographics?.contactNumber,
          },
          {
            label: 'Number for Feedback',
            value: demographics?.consentsToSMS
              ? demographics?.numberForFeedback
              : 'Not Consented',
            fullWidthLabel: true,
          },
        ]}
      />
      <DetailsBox
        title="Next of Kin"
        rows={[
          { label: 'Name', value: demographics?.nokName },
          { label: 'Relationship', value: demographics?.nokRelationship },
          { label: 'Contact Number', value: demographics?.nokContactNumber },
        ]}
      />
    </>
  )
}

export default DemographicsModule
